// ============================================================
// ReboundAM — Main JavaScript v3
// ============================================================

document.addEventListener('DOMContentLoaded', () => {

  // ---- Mobile Menu ----
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose  = document.querySelector('.mobile-menu__close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    menuClose?.addEventListener('click', closeMobileMenu);
    mobileMenu.querySelectorAll('.mobile-menu__link').forEach(l => l.addEventListener('click', closeMobileMenu));
    mobileMenu.addEventListener('click', (e) => { if (e.target === mobileMenu) closeMobileMenu(); });
  }

  function closeMobileMenu() {
    mobileMenu?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  // ---- Search Overlay ----
  const searchOverlay = document.querySelector('.search-overlay');
  const searchBtns    = document.querySelectorAll('.header-search-btn');
  const searchClose   = document.querySelector('.search-overlay__close');
  const searchInput   = document.querySelector('.search-overlay__input');

  function openSearch() {
    searchOverlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 50);
    searchBtns.forEach(b => b.setAttribute('aria-expanded', 'true'));
  }
  function closeSearch() {
    searchOverlay?.classList.remove('is-open');
    document.body.style.overflow = '';
    searchBtns.forEach(b => b.setAttribute('aria-expanded', 'false'));
  }

  searchBtns.forEach(btn => btn.addEventListener('click', openSearch));
  searchClose?.addEventListener('click', closeSearch);
  searchOverlay?.addEventListener('click', (e) => { if (e.target === searchOverlay) closeSearch(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeSearch(); closeMobileMenu(); } });

  // ---- Scroll Animations ----
  const fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(el => obs.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('is-visible'));
  }

  // ---- Cart Count (synced with Shopify /cart.js) ----
  const cartBadge = document.querySelector('.cart-badge');

  function updateCartBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.style.display = count > 0 ? 'flex' : 'none';
  }

  fetch('/cart.js')
    .then(r => r.json())
    .then(data => updateCartBadge(data.item_count))
    .catch(() => {});

  // AJAX Add to Cart
  document.querySelectorAll('.product-card__add-btn, .product-page__add-btn').forEach(btn => {
    if (btn.tagName !== 'BUTTON') return;
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      if (!form) return;
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity  = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) })
        });
        if (!res.ok) throw new Error();
        const cartRes  = await fetch('/cart.js');
        const cartData = await cartRes.json();
        updateCartBadge(cartData.item_count);
        showToast('Added to cart!');
      } catch {
        showToast('Something went wrong. Please try again.');
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    });
  });

  // ---- Toast notification ----
  function showToast(msg) {
    const existing = document.querySelector('.ram-toast');
    if (existing) existing.remove();
    if (!document.querySelector('#ram-toast-styles')) {
      const style = document.createElement('style');
      style.id = 'ram-toast-styles';
      style.textContent = `
        @keyframes toastIn  { from { opacity:0; transform: translateY(20px); } to { opacity:1; transform: translateY(0); } }
        @keyframes toastOut { from { opacity:1; } to { opacity:0; transform: translateY(20px); } }
      `;
      document.head.appendChild(style);
    }
    const toast = document.createElement('div');
    toast.className = 'ram-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = `<span aria-hidden="true">&#10003;</span> ${msg}`;
    toast.style.cssText = [
      'position:fixed', 'bottom:2rem', 'right:2rem', 'z-index:9999',
      'background:#E8621A', 'color:#fff',
      "font-family:'Montserrat',sans-serif", 'font-weight:800', 'font-size:0.88rem',
      'letter-spacing:0.08em', 'text-transform:uppercase',
      'padding:0.85rem 1.5rem', 'border-radius:999px',
      'box-shadow:0 8px 30px rgba(232,98,26,0.45)',
      'animation:toastIn 0.3s ease forwards'
    ].join(';');
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.style.animation = 'toastOut 0.3s ease forwards';
      setTimeout(() => toast.remove(), 300);
    }, 2500);
  }

  // ---- Active nav link ----
  const currentPath = window.location.pathname;
  document.querySelectorAll('.site-nav__link, .mobile-menu__link').forEach(a => {
    const href = a.getAttribute('href');
    if (href && (href === currentPath || (href !== '/' && currentPath.startsWith(href)))) {
      a.classList.add('active');
    }
  });

  // ---- Sticky header shadow ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 4px 30px rgba(0,0,0,0.5)' : 'none';
    }, { passive: true });
  }

  // ---- Newsletter (Shopify handles POST; JS just shows immediate toast) ----
  const nlForm = document.querySelector('.newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', () => {
      const input = nlForm.querySelector('.newsletter-input');
      if (input?.value) showToast('Subscribed! 15% off coming your way.');
    });
  }

  // ---- Reseller / Contact form ----
  const contactForm = document.querySelector('.reseller-form form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const wrapper = contactForm.closest('.reseller-form');
      const success = wrapper?.querySelector('.form-success');
      if (success) success.style.display = 'block';
      contactForm.reset();
      if (wrapper) window.scrollTo({ top: wrapper.offsetTop - 100, behavior: 'smooth' });
    });
  }

  // ---- Animated counters ----
  const counterEls = document.querySelectorAll('[data-counter]');
  if (counterEls.length && 'IntersectionObserver' in window) {
    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el     = entry.target;
        const target = parseInt(el.dataset.counter, 10);
        const suffix = el.dataset.suffix || '';
        const start  = performance.now();
        const dur    = 1800;
        function step(now) {
          const p = Math.min((now - start) / dur, 1);
          const e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.floor(e * target) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.4 });
    counterEls.forEach(el => counterObs.observe(el));
  }

});